import { Alert, Box, CircularProgress } from "@mui/material";
import { useFetchApproval } from "../hooks/useFetchApprovals";
import { Approvals } from "../../../shared/components";

export const ApprovalsDetails: React.FC<{ stageID: string; gateDecision: boolean; refetch: () => void; projectId: string | undefined }> = ({ stageID, gateDecision, refetch, projectId }) => {

    const { isPending, isAdding, isEditing, isUpdating, data, handleUpdateApproval } = useFetchApproval({ stageID, projectId: projectId! });

    const filteredApprovals = data?.filter((s: { is_decision_gate: boolean }) => s.is_decision_gate === gateDecision);
    const isDiabledGateDecision = data?.filter((s: { is_decision_gate: boolean }) => !s.is_decision_gate).some((approval: { status_display_text: string }) => approval.status_display_text.toLowerCase() === "pending");

    const isGateDecisionApproved = data?.filter((s: { is_decision_gate: boolean }) => s.is_decision_gate).some((approval: { status_display_text: string }) => approval.status_display_text.toLowerCase() === "approved");

    if (isPending) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <CircularProgress />
            </Box>
        );
    };

    if (!filteredApprovals || filteredApprovals.length === 0) {
        return (
            <Box
                height="100%"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
                width="100%"
                gap={2}
            >
                <Alert severity="warning">No approvers assigned</Alert>
            </Box>
        );
    };

    return (
        <Box display="flex" flexDirection="column" height="100%" sx={{ overflowY: 'auto', pr: 2 }}>
            {
                filteredApprovals.map((approval: { id: string; status_display_text: "Pending" | "On Hold" | "Approved"; color: "green" | "red" | "amber"; user_name: string; role_name: string; notes: string; updated_date: string; }, index: number) => (
                    <Approvals
                        key={index}
                        status={approval.status_display_text}
                        color={approval.color as "green" | "red" | "amber"}
                        name={approval.user_name}
                        role={approval.role_name}
                        note={approval.notes}
                        date={approval.updated_date}
                        onSave={(status: "on_hold" | "approved" | "pending", notes: string | null) => handleUpdateApproval(approval.id, status, notes).then(() => refetch())}
                        isLoading={isAdding || isEditing || isUpdating}
                        isDiabledGateDecision={gateDecision ? isDiabledGateDecision : isGateDecisionApproved}
                    />
                ))
            }
        </Box>
    );

};